<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<p class="immagine3"><span>Christelle Dabos</span></p>
<p class="immagine1">T<span class="smallcaps">HE</span> M<span class="smallcaps">IRROR</span> V<span class="smallcaps">ISITOR</span> <br/><span class="smallcaps">BOOK 2</span></p>
<p class="immagine4">T<span class="smallcaps">HE</span> M<span class="smallcaps">ISSING <br/>OF</span> C<span class="smallcaps">LAIRDELUNE</span></p>
<p class="immagine2" id="traduzione"><span><i>Translated from the French<br/>
    by Hildegarde Serle</i></span></p>
<div class="immagine"><img alt="" height="92" src="Images/logo.jpg" width="98"/></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Titlepage.vue?4fc17c5b